import React, { createContext, useContext } from 'react';

// Типы для контекста
export interface AuthContextType {
  // Состояния
  currentStep: string;
  authenticationType: string;
  authenticationMethod: string;
  resetPasswordMethod: string;
  spinner: boolean;
  form: {
    email: string;
    phone: string;
    password: string;
    isLegalAge: boolean;
    isTerms: boolean;
    isNews: boolean;
  };
  currentCountry: any;
  currentPhone: string;
  currentEmail: string;
  inputRefs: React.MutableRefObject<any[]>;
  t: (key: string) => string;
  searchParams: URLSearchParams | null;
  digits: string[]; // Состояние для цифр кода подтверждения
  user: any; // Данные пользователя

  // Методы
  setCurrentStep: (step: string) => void;
  setAuthenticationType: (type: string) => void;
  setAuthenticationMethod: (method: string) => void;
  setResetPasswordMethod: (method: string) => void;
  handleClose: () => void;
  onSubmit: (values: any) => Promise<void>;
  handleResetPassword: () => void;
  handleSmsChange: (
    index: number,
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
  handleSmsResend: (values?: any) => void;
  handleEmailResend: () => void;
  handleSmsSubmit: () => void;
  PhoneFieldCmp: React.ComponentType<any>;

  // Валидационные функции
  validate: (values: any) => any;
  validateResetPasswordWithEmail: (values: any) => any;
  validateResetPasswordWithPhone: (values: any) => any;
  validateCreatePassword: (values: any) => any;

  // Новые методы для обработки SMS-кода
  handleDigitChange: (index: number, value: string) => void;
  handleKeyDown: (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>
  ) => void;
  setDigits: React.Dispatch<React.SetStateAction<string[]>>;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
